import type { ComponentType, SVGProps } from 'react';
import {
  Bag,
  Boot,
  CowboyHat,
  Diamond,
  Dress,
  Dresser,
  Handbag,
  HighHeel,
  Hoodie,
  Pants,
  ShirtFolded,
  ShoppingBag,
  Sneaker,
  Sock,
  Tag,
  TShirt,
} from '@phosphor-icons/react';
import {
  Bermuda,
  Biquini,
  Blazer,
  Blusa,
  Body,
  Brinco,
  Calcinha,
  Cardigan,
  Chinelo,
  Cinto,
  Colar,
  Colete,
  Conjunto,
  Cropped,
  Fantasia,
  Jaqueta,
  Kimono,
  Legging,
  Lingerie,
  Macacao,
  Maio,
  MeiaCalca,
  Pijama,
  Polo,
  Pulseira,
  Regata,
  SaidaDePraia,
  Saia,
  Sapato,
  Short,
  Sutia,
  Top,
  Tricot,
} from './icons';

export type CategoryIconComponent = ComponentType<
  { size?: number | string; className?: string } & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'fill'>
>;

export const CATEGORY_ICON_MAP: Record<string, CategoryIconComponent> = {
  blusa: Blusa,
  regata: Regata,
  cropped: Cropped,
  top: Top,
  body: Body,
  camiseta: TShirt,
  camisa: ShirtFolded,
  sutia: Sutia,
  calcinha: Calcinha,
  colete: Colete,
  polo: Polo,
  calca: Pants,
  saia: Saia,
  short: Short,
  bermuda: Bermuda,
  legging: Legging,
  blazer: Blazer,
  casaco: Hoodie,
  jaqueta: Jaqueta,
  cardigan: Cardigan,
  kimono: Kimono,
  vestido: Dress,
  macacão: Macacao,
  macacao: Macacao,
  chinelo: Chinelo,
  sandalia: HighHeel,
  sapato: Sapato,
  tenis: Sneaker,
  bota: Boot,
  cinto: Cinto,
  bolsa: Handbag,
  mochila: Bag,
  colar: Colar,
  brinco: Brinco,
  pulseira: Pulseira,
  bijoux: Diamond,
  acessorio: Tag,
  chapeu: CowboyHat,
  meia: Sock,
  biquini: Biquini,
  maio: Maio,
  saida_de_praia: SaidaDePraia,
  lingerie: Lingerie,
  pijama: Pijama,
  fantasia: Fantasia,
  kit: ShoppingBag,
  tricot: Tricot,
  conjunto: Conjunto,
  meia_calca: MeiaCalca,
  casa_decor: Dresser,
  outros: Tag,
};

export const CATEGORY_DISPLAY_MAP: Record<string, string> = {
  blusa: 'Blusa',
  regata: 'Regata',
  cropped: 'Cropped',
  top: 'Top',
  body: 'Body',
  camiseta: 'Camiseta',
  camisa: 'Camisa',
  sutia: 'Sutiã',
  calcinha: 'Calcinha',
  colete: 'Colete',
  polo: 'Polo',
  calca: 'Calça',
  saia: 'Saia',
  short: 'Short',
  bermuda: 'Bermuda',
  legging: 'Legging',
  blazer: 'Blazer',
  casaco: 'Casaco',
  jaqueta: 'Jaqueta',
  cardigan: 'Cardigan',
  kimono: 'Kimono',
  vestido: 'Vestido',
  macacão: 'Macacão',
  macacao: 'Macacão',
  chinelo: 'Chinelo',
  sandalia: 'Sandália',
  sapato: 'Sapato',
  tenis: 'Tênis',
  bota: 'Bota',
  cinto: 'Cinto',
  bolsa: 'Bolsa',
  mochila: 'Mochila',
  colar: 'Colar',
  brinco: 'Brinco',
  pulseira: 'Pulseira',
  bijoux: 'Bijoux',
  acessorio: 'Acessório',
  chapeu: 'Chapéu',
  meia: 'Meia',
  biquini: 'Biquíni',
  maio: 'Maiô',
  saida_de_praia: 'Saída de Praia',
  lingerie: 'Lingerie',
  pijama: 'Pijama',
  fantasia: 'Fantasia',
  kit: 'Kit',
  tricot: 'Tricot',
  conjunto: 'Conjunto',
  meia_calca: 'Meia-Calça',
  casa_decor: 'Casa & Decor',
  outros: 'Outros',
};

export const FALLBACK_ICON: CategoryIconComponent = Tag;

export const CATEGORY_KEYS = Object.keys(CATEGORY_ICON_MAP) as readonly string[];
